module.exports = __webpack_public_path__ + "img/smart_mirror_logo.02ffb9d3.svg";